import React from 'react';
import { MdShoppingCart } from 'react-icons/md'
import { IoLogoWhatsapp } from 'react-icons/io';
import { FlexboxGrid, Badge, IconButton } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import { navigateWithScrollReset } from '../../utils/scrollUtils';

const CampTopbar = ({ cart, setIsMenu }) => {

  const navigate = useNavigate();
  const cartCount = cart ? cart.length : 0;

  return (
    <div className="relative overflow-hidden bg-white" style={{ borderBottom: '1px solid #E5E7EB' }}>
      {/* Decorative hexagon artwork, clipped to the header */}
      <div
        className="absolute inset-0 bg-blue-tech-hexagon-modern"
        aria-hidden="true"
        style={{ pointerEvents: 'none' }}
      />
      {/* Legibility overlay: near-white caps behind the logo (left) and the
          WhatsApp/cart cluster (right); the pattern shows at full strength
          mid-header. Below lg the logo is centered, so a uniform soft wash
          is used instead (see .camp-header-overlay in index.css). */}
      <div className="camp-header-overlay" aria-hidden="true" />

      {/* Header content above the decorative layers */}
      <FlexboxGrid justify="space-between" align="middle" className="relative" style={{ padding: '3px 0' }}>
        <IconButton onClick={() => setIsMenu(prev => !prev)} className="mobile-menu-button ml-6" icon={<MenuIcon size="2em" />} aria-label="Open menu" />
        <img
          src="/logo.webp"
          alt="Newtonshow"
          style={{ width: '150px', marginTop: 10, marginBottom: 10, marginLeft: 20, cursor: 'pointer' }}
          onClick={() => navigate('/book')}
        />
        <div className="flex flex-row items-center gap-3">
          <a className="hover:no-underline flex flex-row items-center gap-1 phone-number" href="https://wa.me/6589501968" target="_blank" rel="noreferrer" aria-label="Chat with us on WhatsApp">
            <IoLogoWhatsapp size="2em" color="#25d366"/>
            <span className="hidden lg:block">+65 8950 1968</span>
          </a>
          <button
            type="button"
            className="cart-button my-2.5 mr-6 lg:mr-10"
            onClick={() => navigateWithScrollReset(navigate, '/review')}
            aria-label={`Cart, ${cartCount} item${cartCount === 1 ? '' : 's'}`}
          >
            <Badge content={cartCount > 0 ? cartCount : false}>
              <MdShoppingCart size="2em" />
            </Badge>
          </button>
        </div>
      </FlexboxGrid>
    </div>
  )
}

export default CampTopbar;
